import _app from '@modules/theme/pages/_app';

// /**
//  * Import global css
//  * */
import '../core/styles/index.css';
import '../core/styles/mediaquery.css';
import '../core/styles/flexboxgrid.min.css';

export default _app;
